<template>
  <div class="media-box">
    <img
      v-if="general.showMedia && general.media.mediaType === 'image'"
      :src="appendCdnParams(general.media.url)"
      alt=""
      :loading="lazy ? 'lazy' : 'eager'"
    />

    <video
      v-else-if="general.showMedia && general.media.mediaType === 'video'"
      ref="videoElement"
      autoplay
      playsinline
      loop
      muted
      :src="general.media.url"
    />

    <div
      v-if="general.showMedia && general.media.mediaType === 'video'"
      class="controls-container"
    >
      <div class="control-wrapper">
        <button
          class="media-control-button"
          :aria-label="isPlaying ? 'Pause video' : 'Play video'"
          @click="togglePlayPause"
        >
          <span v-if="isPlaying" class="pause-icon"></span>
          <span v-else class="play-icon"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { globalMethods } from "../../GlobalUI/mixins/global.js";

export default {
  name: "CoverUIMedia",
  mixins: [globalMethods],
  props: {
    general: {
      type: Object,
      default() {
        return {};
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPlaying: true,
    };
  },
  methods: {
    togglePlayPause() {
      const video = this.$refs.videoElement;
      if (!video) return;
      if (this.isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      this.isPlaying = !this.isPlaying;
    },
  },
};
</script>

<style lang="scss" scoped>
.media-box {
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: relative;

  img,
  video {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .controls-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    pointer-events: none;
  }

  .control-wrapper {
    position: absolute;
    bottom: calc(var(--cr-nav-height) + 16px);
    right: 16px;
  }

  .media-control-button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.5);
    border: 2px solid transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    padding: 0;
    pointer-events: all;

    &:hover,
    &:focus {
      background-color: rgba(0, 0, 0, 0.7);
      border-color: white;
      outline: none;
    }

    .pause-icon {
      width: 12px;
      height: 16px;
      position: relative;

      &::before,
      &::after {
        content: "";
        position: absolute;
        width: 4px;
        height: 16px;
        background-color: white;
        top: 0;
      }

      &::before {
        left: 0;
      }

      &::after {
        right: 0;
      }
    }

    .play-icon {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 8px 0 8px 14px;
      border-color: transparent transparent transparent white;
      margin-left: 3px;
    }
  }
}
</style>
